// Payment System v3.0 (WS1) — shared query keys for the Servicer Instruction
// Report surfaces (mirrors pirKeys).

export const servicerInstructionKeys = {
  list: ["servicer-instructions"] as const,
  detail: (id: string | undefined) =>
    ["servicer-instruction", id] as const,
};
